module.exports = __webpack_public_path__ + "img/viewpoint3.c870f572.png";